var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "PanelRow",
        [
          _c(
            "Panel",
            { staticClass: "two-thirds" },
            [
              _c("h1", { attrs: { slot: "header" }, slot: "header" }, [
                _vm._v(_vm._s(_vm._f("trans")("titles.users")))
              ]),
              _vm._v(" "),
              _c(
                "nav",
                {
                  staticClass: "controls-bar",
                  attrs: { slot: "header" },
                  slot: "header"
                },
                [
                  _c("DebouncedSearch", {
                    model: {
                      value: _vm.search,
                      callback: function($$v) {
                        _vm.search = $$v
                      },
                      expression: "search"
                    }
                  }),
                  _vm._v(" "),
                  _vm.apptokenLimitOpts
                    ? _c("ButtonSwitch", {
                        attrs: {
                          options: _vm.apptokenLimitOpts,
                          classname: "lg"
                        },
                        model: {
                          value: _vm.noApptokenLimit,
                          callback: function($$v) {
                            _vm.noApptokenLimit = $$v
                          },
                          expression: "noApptokenLimit"
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _vm.list
                ? _c("UserList", {
                    attrs: {
                      fields: _vm.fields,
                      items: _vm.list.list,
                      url: _vm.itemurl
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("Pages", {
                attrs: { pages: _vm.pages },
                model: {
                  value: _vm.p,
                  callback: function($$v) {
                    _vm.p = $$v
                  },
                  expression: "p"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-38876cf6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38876cf6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/sections/general/Invoices.vue
// module id = null
// module chunks = 